import React, {useEffect} from 'react'
import TableAdapter from "../../../components/TableAdapter/TableAdapter";
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";
import {getStateByPath} from "../../../redux/selectors";


// components
import ParamSettingsForm from "./_form";
import ParamSettingsFilters from "./_filters";
import { ConfirmDelete } from "../../../components/confirmAlert/ConfirmDelete";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";

// labels
import {
    LIST,
    NO_DATA_FOUND,
} from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";

// actions
import {GenericButton} from "../../../components/buttons/customButtons";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";

// services
import {paramSettingsService} from "../../../jwt/_services/hotel/paramsSettingsService";


const ParamSettingsList = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const {listDomainObjects} = componentState?.data || [];
    const { app, pageSize, pageIndex, totalSize, filter } = componentState?.data || {};

    // asignar los valores por default del filtro
    useEffect( () => {
        if (!props.generalPropouse) {
            if (!app?.fbDataBase?.id || filter)
                return;

            const _filter = {
                onlyRegistered : true,
                fbDataBase : { id : app?.fbDataBase?.id },
                item : {
                }
            };

            props.setFilter(path, _filter);
        } else {
            const _filter = {
                onlyRegistered : false,
                item : {
                }
            };

            props.setFilter(path, _filter);
        }
    }, [ app ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, paramSettingsService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path,  tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        if (!props.generalPropouse) {
            return ConfirmDelete({
                path,
                remove : genericIndexedActions.delete,
                data : data,
                fbDataBaseId :  app?.fbDataBase?.id,
                service: paramSettingsService
            });
        } else {
            return ConfirmDelete({
                path,
                remove : genericIndexedActions.hardDelete,
                data : data,
                service: paramSettingsService
            });
        }
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( ParamSettingsForm, { path, generalPropouse : props.generalPropouse } )
    }

    const editItem = (data) => {
        props.setForm(path,true, false, false);
        props.setItem(path,data);
        ModalFormContainer(ParamSettingsForm, { path, data, Form: ParamSettingsForm, generalPropouse : props.generalPropouse })
    }

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'ps_key',
        text: 'Llave',
        headerStyle: {width: '220px'},
    },{
        dataField: 'ps_value_max',
        text: 'Valor',
    },{
        dataField: 'actions',
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '180px'},
        align: 'center',
        headerAlign: 'center',
        formatter: actionsFormatter
    }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <ParamSettingsFilters path={path} generalPropouse={props.generalPropouse} />
            <TableAdapter
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={NO_DATA_FOUND}
                pagination={{pageIndex, pageSize, totalSize}}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(ParamSettingsList)